<template>
  <div class="generate-content">
    <div class="comp-list board" id="left">
      <div v-for="item in compList" :key="item.index" class="comp-item">
        <div class="el-icon-eleme"></div>
        <div>{{ item.label }}</div>
      </div>
    </div>

    <div class="table-compress-board board">
      <div style="display: flex; margin-bottom: 6px">
        <el-button icon="el-icon-circle-add" size="mini" type="primary" style="margin-left: auto"
          @click="onSaveClick">保存</el-button>
      </div>
      <div style="height: 240px; display: flex; overflow: auto" id="right">
        <XxTable :columnList="columnList" @setActive="setActive" @sort="setColumnSort" @delColumn="onDelColumn"
          :showClose="closeUse" />
      </div>
      <el-divider class="divider" />
      <div style="display: flex; margin: 8px 5px">
        <el-button type="primary" style="margin-left: auto" size="mini" @click="saveTable">{{ $t("message.button.save")
        }}</el-button>
        <el-button size="mini" style="margin-right: 15px" @click="cancel" v-if="compKey !== ''">
          返回
          <!-- {{  // $t("message.button.cancel")  '返回'        }} -->
        </el-button>
      </div>
      <div>
        <!-- <ColumnPanel :column="columnItem" :key="compKey" /> -->
        <div v-if="compKey === ''">
          <table-panel :tableInfo="tableInfo" @edit="editTable" />
        </div>
        <ColumnPanel :panelItem="panelItem" :key="compKey" @edit="editPanel" v-else />
      </div>
      <!-- <div class="table-panel "></div> -->
    </div>
  </div>
</template>

<script>
import * as api from "./configAPI";
import Sortable from "sortablejs";
import draggable from "vuedraggable";
import XxTable from "./xx-table.vue";
// import ColumnPanel from "../../columnPanel.vue";
import TablePanel from "./tablePanel.vue";
import ColumnPanel from "./panel.vue";
import FormRender from "../../formRender/index.vue";
import { getCompConfig, tableConfig } from "./attriConfig";

export default {
  data() {
    return {
      compList: [
        { label: "单行文本", uiType: 1 },
        { label: "数字文本", uiType: 7 },
        { label: "多行文本", uiType: 2 },
        { label: "单选列表", uiType: 3 },
        { label: "多选列表", uiType: 4 },
        { label: "日期组件", uiType: 6 },

        // { label: "只读字段", uiType: 1, readOnlyAttribute: 1 },
      ],
      columnList: [],
      list: [],
      columnItem: [],
      compKey: "",

      panelItem: {},
      sortList: new Map(),
      editTableInfo: {},
      closeUse: true,

      // tableFormConfig: {},
    };
  },
  props: {
    tableInfo: {
      type: Object,
      default: {},
    },
  },
  watch: {
    tableInfo(val) {
      console.log(val);
    },
  },
  components: { draggable, XxTable, FormRender, ColumnPanel, TablePanel },
  methods: {
    setSingleAttr() {
      const attributes = this.getSingleData(),
        { id = "" } = this.tableInfo;
      console.log(attributes);
      const [item] = attributes;

      if (item.name === "") {
        this.$message.error(this.$t("message.error.name"));
        return;
      }

      api.upDateAttriAPI({ attributes, id }).then((res) => {
        if (res.data.code == 200) {
          const { attributes } = res.data.object;
          const [item] = attributes;
          this.columnList[this.compKey].id = item.id;
          this.$message.success(res.data.message);

        }
      });
    },
    getSingleData(item) {
      const { attrOrder, required, name, uiType, id, listValue } =
        this.columnList[this.compKey];
      console.log({ item, k: this.columnList[this.compKey] });

      console.log(typeof (id));


      const xx = (typeof (id)) === 'symbol' ? null : id;
      return [
        {
          attrOrder,
          uiType,
          name,
          listValue,
          id: xx,
          required: required ? 1 : 0,
          config: {
            width: "120px",
          },
          defaultValue: null,
          descrition: "",
        },
      ];
    },
    cancel() {
      this.compKey = ''
      this.columnItem = tableConfig;
      return;
    },
    setColumnSort(data) {
      this.sortList = new Map(data);
    },
    getData() {
      const { columnList = "" } = this.tableInfo;
      if (columnList) {
        this.columnList = [...columnList];
      }
    },
    editPanel(val) {
      // console.log(val);
      const { name, uiType, listValue, required } = val;
      const item = this.columnList[this.compKey],
        obj = { name, uiType, listValue, required };
      for (const key in obj) {
        console.log(key);
        item[key] = obj[key];
      }
    },
    editTable(val) {
      console.log(val);
      const { desc, name, visiabled, } = val;
      this.editTableInfo = { ...this.tableInfo, enabled: visiabled ? 1 : 0, name, desc };
    },
    onDragStart(event) { },
    setActive(data) {
      console.log(data);

      const { index, id } = data;
      this.compKey = index;
      if (index === "") {
        this.columnItem = tableConfig;
        return;
      }

      const item = this.columnList.find(i => i.id == id);
      console.log(item, id);

      console.log(item, this.compKey);
      this.panelItem = item;
    },
    onDelColumn(index) {
      const item = this.columnList[index];
      const { id: deleteAttributeId } = item;
      if (typeof (deleteAttributeId) === 'symbol') {
        this.columnList.splice(index, 1);
        return;
      }
      const { id } = this.tableInfo;
      const obj = { deleteAttributeId, id };
      api.deleteAttriAPI(obj).then((res) => {
        this.$message.success(res.data.message);
        this.columnList.splice(index, 1);
      });
    },
    getSortElement(event) {
      const { oldIndex } = event;
      const item = { ...this.compList[oldIndex], id: Symbol('id') };

      item.name = item.label;
      item.attrOrder = this.columnList.length + 21;

      if (item.uiType === 3 || item.uiType === 4) {
        item.listValue = "-1";
      }

      this.panelItem = item;
      this.columnList.push(item);
    },
    checkName(attributes) {
      const s = attributes.some((i) => i.name === "");
      return s;
    },
    onSaveClick() {
      const { id = "" } = this.tableInfo;

      if (!id) {
        this.$message.error("请保存表格设置");
        return;
      }
      const attributes = this.getAttriData(id);
      const obj = { attributes, id };

      if (this.checkName(attributes)) {
        this.$message.error(this.$t("message.error.name"));
        return;
      }

      api.upDateAttriAPI(obj).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.columnList = res.data.object.attributes.map(i => {
            i.required = Boolean(Number(i.required));
            return i
          })
          this.$message.success(res.data.message);
        }
      });
    },

    saveTable() {

      const { id: tableId } = this.tableInfo

      if (this.compKey !== "") {
        if (!tableId) {
          this.$message.error("请保存表格设置");
          return;
        }
        this.setSingleAttr();
        return;
      }
      const { subClsesId: subclassId } = this.$route.query;
      const { name, desc, visiable, enabled, id } = { ...this.tableInfo, ...this.editTableInfo, };

      console.log({ name, enabled });

      if (name === undefined || name === "") {
        this.$message.error(this.$t("message.error.name"));
        return;
      }
      const obj = {
        classId: "",
        description: desc,
        enabled,
        name,
        visiable,
        id: id || null,
        subclassId,
      };
      api.saveTableFrame(obj).then((res) => {
        const {
          message,
          object: { id },
        } = res.data;
        this.$set(this.tableInfo, "id", id);
        this.$message.success(message);
      });
    },
    getAttrOrder(item) {
      const { id, attrOrder } = item;
      if (!this.sortList.size) {
        return attrOrder;
      }
      return this.sortList.get(id);
    },
    getAttrId(item) {
      const { id } = item;
      if ((typeof (id)) !== 'symbol') {
        return id;
      }
      return null;
    },
    getAttriData(id) {
      const setData = (item, e) => {
        const { listValue, uiType } = item;
        const attrOrder = this.getAttrOrder(item);
        const id = this.getAttrId(item),
          required = 0;

        return {
          attrOrder,
          id,
          required,
          listValue,
          uiType,
          config: {
            width: "120px",
          },
          defaultValue: null,
          descrition: "",
          name: item.name,
        };
      };
      console.log(this.columnList);


      const attributes = this.columnList.map((i, e) => setData(i, e));
      return attributes;
    },
  },
  mounted() {
    this.getData();
    const { getSortElement } = this;
    const left = document.getElementById("left"),
      right = document.getElementById("right");
    new Sortable(left, {
      group: {
        name: "shared",
        pull: "clone",
        put: false, // 不允许拖拽进这个列表
      },
      animation: 150,
      sort: false, // 设为false，禁止sort

      onEnd: function name(event) {
        getSortElement(event);
      },
    });

    new Sortable(right, {
      group: "shared",
      animation: 150,
      onUpdate: function (event) { },
    });

    this.columnItem = [...tableConfig];
  },
  created() {
    // this.getData();
  },
};
</script>

<style scoped lang="scss">
.divider {
  margin: 6px 0;
}

.generate-content {
  display: flex;
  gap: 0.6em;
  // height: 100%;
  height: 600px;
  overflow: auto;

  .board {
    // background-color: aliceblue;
    border-radius: 6px;
    border: 1px solid #e4e4e7;
  }

  .comp-list {
    // flex: 1;
    width: 120px;
    padding: 10px;
    box-sizing: border-box;

    // flex-basis: 150px;
    .comp-item {
      cursor: pointer;
      font-size: 12px;
      border: dashed 1px #e4e4e7;
      border-radius: 6px;
      padding: 6px;
      text-align: center;
      margin-bottom: 6px;
      box-sizing: border-box;
    }
  }

  .table-compress-board {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 80%;
    overflow: auto;
    padding: 10px;
    box-sizing: border-box;

    .table-panel {
      height: 300px;
    }
  }
}

#right {
  .comp-item {
    display: none;
  }
}

.column-item {
  border: solid 1px #e4e4e7;
  padding: 6px 10px;
  cursor: pointer;
  width: 120px;
}
</style>